function sendUtagEvent(data) {
  // No se puede importar sendUtagEvent desde el frontend
  UtagLayerHandler.pushData(JSON.stringify(data))
}

function initializeContentSiteEvents() {
  document.querySelectorAll('.utag-share-article').forEach(element => {
    element.addEventListener('click', function (event) {
      const target = event.target
      if (!target.matches('.utag-share-article')) {
        target.closest('.utag-share-article').click()
      } else {
        const data = {
          event_cat: 'social events',
          event_act: 'share article',
          event_lbl: target.dataset.socialNetwork,
        }
        sendUtagEvent(data)
      }
    })
  })

  document.querySelectorAll('.utag-language-link').forEach(element => {
    element.addEventListener('click', function (event) {
      const target = event.target
      if (!target.matches('.utag-language-link')) {
        target.closest('.utag-language-link').click()
      } else {
        const data = {
          event_cat: 'change page info',
          event_act: 'language',
          event_lbl: target.dataset.locale,
        }
        sendUtagEvent(data)
      }
    })
  })

  document.querySelectorAll('.utag-video-article').forEach(element => {
    element.addEventListener('click', function (event) {
      const target = event.target
      if (!target.matches('.utag-video-article')) {
        target.closest('.utag-video-article').click()
      } else {
        const data = {
          event_cat: 'videos',
          event_act: 'play',
          event_lbl: target.dataset.title,
        }
        sendUtagEvent(data)
      }
    })
  })

  document.querySelectorAll('.utag-button-footer-image').forEach(element => {
    element.addEventListener('click', function (event) {
      const target = event.target
      if (!target.matches('.utag-button-footer-image')) {
        target.closest('.utag-button-footer-image').click()
      } else {
        const data = {
          event_cat: 'make it real now',
          event_act: 'inspiration guide',
          event_lbl: '',
        }
        sendUtagEvent(data)
      }
    })
  })

  document.querySelectorAll('.utag-book-now-header').forEach(element => {
    element.addEventListener('click', function (event) {
      const target = event.target
      if (!target.matches('.utag-book-now-header')) {
        target.closest('.utag-book-now-header').click()
      } else {
        const data = {
          event_cat: 'book now',
          event_act: 'inspiration guide',
          event_lbl: '',
        }
        sendUtagEvent(data)
      }
    })
  })
}

initializeContentSiteEvents()
